import TotalBalanceApi from "./TotalBalanceApi";
export default TotalBalanceApi;
